<template>
  <div class="corporateCulture">
    <Header @ck="onclick($event)"></Header>
    <slideshow></slideshow>
    <div class="content_c">
      <div class="drop-down">
        <el-tabs :tab-position="tabPosition" v-model="Name">
          <el-tab-pane label="文化理念" name="1">
            <div class="rightData whll">
              <div class="business">
                <span class="titlebar">文化理念</span>

                <div class="arrow-right">
                  <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/' }">你现在所在的位置</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item>企业文化</el-breadcrumb-item>
                    <el-breadcrumb-item>文化理念</el-breadcrumb-item>
                  </el-breadcrumb>
                </div>
              </div>
              <div class="related_box">
                <div class="related">
                  <div v-for="(item, index) in list" :key="index">
                    <div v-html="item.content" style='white-space: pre-wrap;' class="ql-editor"></div>
                    <!-- <div class="enterpriseSlogan" >
                      <span>{{ item.title }}</span>
                    </div>
                    <div class="enterpriseSlogan_cont" v-html="item.content"></div> -->
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="党建工作" name="2">
            <div class="rightData djgzz">
              <div class="business">
                <span class="titlebar">党建工作</span>

                <div class="arrow-right">
                  <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/' }">你现在所在的位置</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item>企业文化</el-breadcrumb-item>
                    <el-breadcrumb-item>党建工作</el-breadcrumb-item>
                  </el-breadcrumb>
                </div>
              </div>
              <div class="hezi">
                <div class="enterprise_name">
                  <p class="personne2">党建工作</p>
                </div>
                <div class="news_box1">
                  <div class="InformationNews">
                    <el-carousel indicator-position="outside">
                      <el-carousel-item v-for="(items, indexs) in work" :key="indexs">
                        <div class="imgs">
                          <img :src="url + items.image" @click="Companynews(items.id, 2, listQuerys.pageNums)" />
                        </div>
                      </el-carousel-item>
                    </el-carousel>

                    <!-- <img src="../../assets/djgz.jpg" alt="" /> -->
                    <!-- <img src="../../assets/img/xinw04.jpg" alt /> -->
                  </div>
                  <div class="newsContent">
                    <div class="first"></div>
                    <p class="first_text" v-for="(item, index) in work" :key="index"
                      @click="Companynews(item.id, 2, listQuerys.pageNums)">
                      {{ item.title }}
                    </p>
                  </div>
                </div>
                <el-pagination v-if="this.qw == 1" @size-change="handleSizeChange" @current-change="handleCurrentChange"
                  :current-page="listQuerys.pageNums" :page-sizes="[5, 10, 15, 20]" :page-size="listQuerys.pageSizes"
                  layout="total, sizes, prev, pager, next, jumper" :total="totals">
                </el-pagination>
                <el-pagination v-if="this.qw == 2" small @size-change="handleSizeChange"
                  @current-change="handleCurrentChange" :current-page="listQuerys.pageNums" :page-sizes="[5, 10, 15, 20]"
                  :page-size="listQuerys.pageSizes" layout="prev, pager, next,sizes" :total="totals">
                </el-pagination>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="视频导播" name="3">
            <div class="rightData spdbo">
              <div class="business">
                <span class="titlebar">视频导播</span>

                <div class="arrow-right">
                  <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/' }">你现在所在的位置</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item>企业文化</el-breadcrumb-item>
                    <el-breadcrumb-item>视频导播</el-breadcrumb-item>
                  </el-breadcrumb>
                </div>
              </div>
              <div class="videoDirector">
                <div class="video_box" v-for="(item, index) in playback" :key="index"
                  @click="video_box(item.id, 3, listQuery.pageNum)">
                  <div class="video_img">
                    <img :src="url + item.image" alt="" />
                  </div>
                  <p class="video_text">{{ item.title }}</p>
                </div>
              </div>
              <!-- <pagination
                v-show="total > 0"
                :total="total"
                :page.sync="listQuery.pageNum"
                :limit.sync="listQuery.pageSize"
                @pagination="getShowLists"
              /> -->
              <el-pagination v-if="this.qw == 1" @size-change="handleSizeChanges" @current-change="handleCurrentChanges"
                :current-page="listQuery.pageNum" :page-sizes="[5, 10, 15, 20]" :page-size="listQuery.pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="total">
              </el-pagination>

              <el-pagination v-if="this.qw == 2" @size-change="handleSizeChanges" @current-change="handleCurrentChanges"
                :current-page="listQuery.pageNum" :page-sizes="[5, 10, 15, 20]" :page-size="listQuery.pageSize"
                layout="prev, pager, next,sizes" :total="total">
              </el-pagination>
            </div>
          </el-tab-pane>
          <el-tab-pane label="荣誉室" name="4">
            <div class="rightData rys">
              <div class="business">
                <span class="titlebar">荣誉室</span>

                <div class="arrow-right">
                  <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/' }">你现在所在的位置</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item>企业文化</el-breadcrumb-item>
                    <el-breadcrumb-item>荣誉室</el-breadcrumb-item>
                  </el-breadcrumb>
                </div>
              </div>
              <ul class="SomeSilverware">
                <li v-for="(item, index) in img" :key="index">
                  <img :src="url + item.image" alt />
                  <div style="font-size: 16px">{{ item.title }}</div>
                </li>
              </ul>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div></div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "../../components/haed/haed";
import Footer from "../../components/haed/footer";
import slideshow from "../../components/haed/slideshow";
import pagination from "../../components/haed/pagination";
import qs from "qs";
export default {
  name: "corporateCulture",
  components: {
    Header,
    Footer,
    slideshow,
    pagination,
  },
  data() {
    return {
      cur: 1,
      activeNames: ["1"],
      arr: true,
      list: [],
      playback: [],
      img: [],
      work: [],
      Name: "1",
      listQuery: {
        bsId: "",
        pageNum: 1,
        pageSize: 3,
      },
      listQuerys: {
        bsId: "",
        pageNums: 1,
        pageSizes: 3,
      },
      total: 3,
      totals: 3,
      tabPosition: "left",
      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度
      qw: "",
      url:this.$axios.defaults.baseURL,
    };
  },
  created() {
    if (this.windowWidth > 1000) {
      this.qw = 1;
    } else if (this.windowWidth < 1000) {
      this.qw = 2;
    }
    this.culturalConcept();

    this.Somesilverware();
    // this.Thefoundingwork();
    if (this.$route.query.name) {
      this.Name = this.$route.query.name;
    }
    if (this.$route.query.page) {
      this.listQuerys.pageNums = this.$route.query.page * 1;
      if (this.$route.query.sp) {
        this.listQuery.pageNum = this.$route.query.sp * 1;
      }
    }
  },
  watch: {
    windowHeight(val) {
      let that = this;
      // console.log("实时屏幕高度：",val, that.windowHeight );

      // console.log(val, "实时屏幕高度：");
      // this.qq= val
    },
    windowWidth(val) {
      let that = this;
      console.log("实时屏幕宽度：", val, that.windowWidth);
      // console.log(val, "实时屏幕宽度：");
      if (that.windowWidth > 1000) {
        this.qw = 1;
      } else if (that.windowWidth < 1000) {
        this.qw = 2;
      }
    },
  },
  mounted() {
    this.Thefoundingwork();
    this.Videoplayback();
  },

  methods: {
    onclick(data) {
      console.log("123", data);
      this.Name = data;
    },
    handleSizeChanges(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChanges(val) {
      this.listQuery.pageNum = val;
      this.$axios({
        // method: "post",
        // url: "/index.php/show/showlist",
        // data: qs.stringify({
        //   id: 15,
        //   pageNum: val,
        //   pageSize: 5,
        // }),
        method: "get",
        url: "/changhang/index/list?menu=1&type=4",
        data: qs.stringify({
          pageNum: val,
          pageSize: 5,
        }),
      })
        .then((res) => {
          console.log("111" + res);
          this.playback = res.data.rows;
          this.total = res.data.total;
        })
        .catch((res) => {
          console.log("1111111" + res);
        });
      console.log(`当前页: ${val}`);
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.listQuerys.pageNums = val;
      this.$axios({
        // method: "post",
        // url: "/index.php/show/showlist",
        data: qs.stringify({
          pageNum: val,
          pageSize: 5,
        }),
        method: "get",
        url: "/changhang/index/list?menu=5&type=42",
      })
        .then((res) => {
          console.log("111" + res);
          this.work = res.data.rows;
          this.totals = res.data.total;
        })
        .catch((res) => {
          console.log("1111111" + res);
        });
      console.log(`当前页: ${val}`);
    },
    changePlay(e) {
      var idx = e.target.id ? e.target.id : e.target.dataset.id;
      var vide = document.getElementById(idx);
      if (vide.paused) {
        vide.play();
      } else if (vide.play()) {
        vide.pause();
      }
    },

    changePlay(e) {
      var idx = e.target.id ? e.target.id : e.target.dataset.id;
      var newVis = document.getElementById(idx);
      if (this.old_id == idx) {
        if (newVis.paused) {
          newVis.play();
        } else if (newVis.play()) {
          newVis.pause();
        }
      } else {
        if (this.old_id && document.getElementById(this.old_id).play()) {
          document.getElementById(this.old_id).pause();
        }
        if (newVis.paused) {
          newVis.play();
        }
      }
      this.old_id = idx;
    },

    Companynews(id, name, page) {
      this.$router.push({
        path: "/xq?id=" + id + "&name=" + name + "&page=" + page,
      });
    },
    video_box(id, name, sp) {
      this.$router.push({
        path: "/video?id=" + id + "&name=" + name + "&sp=" + sp,
      });
    },
    handleChange(val) {
      console.log(val);
    },
    getShowLists() {
      this.Videoplayback();
    },
    culturalConcept: function () {
      this.$axios({
        // method: "post",
        // url: "/index.php/show/showlist",
        // data: qs.stringify({
        //   id: 12,
        // }),
        method: "get",
        url: "/changhang/index/list?menu=5&type=41",

      })
        .then((res) => {
          this.list = res.data.rows;
          console.log(this.list, "list");

        })
        .catch((res) => {
        });
    },

    Videoplayback: function () {
      this.$axios({
        // method: "post",
        // url: "/index.php/show/showlist",
        // data: qs.stringify({
        //   id: 15,
        //   pageNum: this.listQuery.pageNum,
        //   pageSize: 5,
        // }),
        method: "get",
        url: "/changhang/index/list?menu=1&type=4",
      })
        .then((res) => {
          console.log("111" + res);
          this.playback = res.data.rows;
          this.total = res.data.total;
        })
        .catch((res) => {
          console.log("1111111" + res);
        });
    },
    Somesilverware: function () {
      this.$axios({
        // method: "post",
        // url: "/index.php/show/showlist",
        // data: qs.stringify({
        //   id: 16,
        // }),
        method: "get",
        url: "/changhang/index/list?menu=5&type=44",
      })
        .then((res) => {
          console.log("111" + res);
          this.img = res.data.rows;
        })
        .catch((res) => {
          console.log("1111111" + res);
        });
    },
    Thefoundingwork: function () {
      this.$axios({
        // method: "post",
        // url: "/index.php/show/showlist",
        // data: qs.stringify({
        //   id: 14,
        //   pageNum: this.listQuerys.pageNums,
        //   pageSize: 5,
        // }),
        method: "get",
        url: "/changhang/index/list?menu=5&type=42",
      })
        .then((res) => {
          console.log("111" + res);
          this.work = res.data.rows;
          this.totals = res.data.total;
        })
        .catch((res) => {
          console.log("1111111" + res);
        });
    },
    shows() {
      this.arr = !this.arr;
    },
  },
};
</script>
   

<style scoped>
.el-pagination {
  padding-bottom: 5%;
  width: 96%;
  text-align: center;
}

.video_box:hover {
  cursor: pointer;
}

.video_box {
  width: 32%;
  height: 200px;
  margin-top: 20px;
  margin-bottom: 2%;
}

.video_img {
  width: 100%;
  height: 180px;
}

.video_img img {
  width: 100%;
  height: 100%;
}

.video_text {
  text-align: center;
  font-size: 16px;
}

.el-tabs__item {
  padding: 0;
}

.el-tabs--left .el-tabs__item.is-left {
  padding-right: 20px;
}

.imgs {
  width: 10vw;
  height: 10vw;
}

.imgs img {
  width: 100%;
  height: 100%;
}

.playback_text {
  /* font-size: 24px;
    margin: 0 auto; */
  /* margin-left: 120px; */
  width: 300px;
  overflow: hidden;
  font-size: 16px;
}

.title_text {
  font-size: 16px;
  color: #3d3d3d;
}

.el-collapse {
  border-top: none;
}

.videoDisplay {
  /* width: 19vw;
  height: 20vw; */
  width: 300px;
  height: 200px;
  border-radius: 20px;
  margin-top: 10px;
}

.Pagination_box {
  text-align: center;
  margin-top: 20px;
  margin-bottom: 20px;
}

.adds {
  position: absolute;
  height: 52px;
  width: 50px;
  top: 79px;
  left: 42%;
  background: url("../../assets/img/f8b38d87c92fdaa8a1e3b10c6308d34.png") no-repeat;
  background-size: 100%;
}

.add img {
  width: 100%;
  height: 600px;
  margin-top: 20px;
  margin-bottom: 20px;
}

.content_c {
  /* height: 1200px; */
  display: flex;
  margin-top: 20px;
}

.drop-down {
  width: 1000px;
  /* margin-left: 30px; */
  margin-top: 20px;
  margin: auto;
}

.rightData {
  width: 90%;
  margin-left: 40px;
  margin-bottom: 5%;
  margin-top: -3%;
}

.enterpriseSlogan {
  display: flex;
  margin-top: 2%;
  justify-content: space-between;
  flex-wrap: wrap;
}

.enterpriseSlogan span {
  color: #3d3d3d;
  font-size: 22px;
  font-weight: bold;
}

.enterpriseSlogan_cont {
  display: flex;
  flex-wrap: nowrap;
  color: #6b6b6b;
  font-size: 16px;
  line-height: 1.5vw;
}

.SomeSilverware {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 1%;
}

.SomeSilverware li {
  width: 30%;
  /* margin-top: 30px; */
  margin-bottom: 8%;
}

.SomeSilverware li img {
  width: 100%;
  height: 100%;
}

.SomeSilverware li img:hover {
  box-shadow: 0 0 12px 1px #c5e4f9;
}

.videoDirector {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-right: 10%;
}

.videoDirector li {
  /* width: 21%; */
  margin: 10px;
}

.videoDirector li img {
  width: 100%;
  height: 100%;
}

.block {
  text-align: center;
}

.related_box {
  display: flex;
}

.related {
  width: 95%;
}

.relatedx {
  width: 72%;
}

.boundary {
  height: 100%;
  border-left: 1px solid #eee;
  display: block;
  margin-left: 21px;
  margin-top: 22px;
}

.boundary_box {
  display: flex;
}

.icon_box {
  text-align: center;
  margin-left: 5vw;
}

.icon_box div {
  margin: 15px;
}

.theFoundingWork {
  display: flex;
}

.theFoundingWork_left {
  width: 54%;
  margin-top: 4%;
}

.theFoundingWork_left,
img {
  width: 66%;
}

.theFoundingWork_left div {
  width: 66%;
  color: #11479f;
  font-size: 1vw;
  line-height: 2;
  margin: 50px 0;
}

.el-divider--vertical {
  height: 58vw;
  left: -5%;
}

.theFoundingWork_rigth {
  width: 65%;
}

.theFoundingWork_rigth div {
  width: 66%;
  color: #11479f;
  font-size: 1vw;
  line-height: 2;
  margin: 50px 0;
}

.crumbs {
  display: flex;
}

.crumbs span {
  color: #969696;
}

.el-breadcrumb {
  font-size: 16px;
  line-height: 1.5;
  color: #969696;
}

.el-menu {
  border-right: none;
}

.left_tac {
  text-align: center;
  display: block;
}

.slash {
  text-align: center;
  border: 1px solid #eee;
  margin: 0 0 -1px -1px;
  line-height: 1.9vw;
  height: 1.9vw;
}

.business {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #dcdcdc;
  margin: 15px 0;
}

.titlebar {
  font-weight: bold;
  font-size: 32px;
  line-height: 2;
  color: #31518c;
}

.el-row {
  padding-left: 5%;
}

.el-submenu .el-menu-item {
  min-width: 1px;
}

.el-collapse-item__header {
  width: 8% !important;
  font-size: 20px !important;
}

/* xxxxx */
.hezi {
  /* border: 1px solid red; */
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
  border-radius: 10px;
}

.enterprise_name {
  font-size: 1.5vw;
  text-align: center;
  background-color: #f1f1f1;
  padding: 1%;
  border-radius: 10px 10px 0px 0px;
}

.personne2 {
  color: #707070;
  font-weight: bold;
}

.enterprise_box {
  width: 100%;
  height: 17vw;
  margin-top: 1vw;
  display: flex;
  justify-content: space-between;
}

.enterprise_img {
  width: 15vw;
  height: 15vw;
}

.enterprise_img img {
  width: 100%;
  height: 100%;
}

.enterprise_text {
  width: 80%;
  height: 100%;
  font-size: 1.5vw;
}

.Organization_box {
  width: 80%;
  height: 17vw;
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}

.InformationNews {
  width: 40%;
  /* height: 200px; */
  margin-left: 5%;
}

.InformationNews .imgs {
  width: 100%;
  height: 65%;
}

/* .Organization{
  width: 80%;
  height: 10vw;
  background: darkgreen;
} */
.Organization_img {
  width: 35vw;
  height: 17vw;
  background: url("../../assets/img/gss07.jpg") no-repeat;
  background-size: 100%;
  text-align: center;
  line-height: 18vw;
  font-size: 2vw;
  color: #fff;
}

.Company_box {
  width: 100%;
  height: 2vw;
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  border-bottom: 1px solid #dedede;
}

.Company_text {
  font-weight: bold;
  font-size: 32px;
  color: #0c47a1;
  text-align: center;
  line-height: 2vw;
  margin-left: 10px;
  margin-top: -0.5vw;
}

.arrow-right {
  text-align: center;
  padding-top: 15px;
  margin-top: 1%;
}

.english {
  margin: 0 auto;
  font-size: 1vw;
  text-align: center;
  color: #0b449d;
}

.ys {
  color: #ccc;
}

.Piece {
  width: 10%;
  height: 0.1vw;
  background-color: #0b449d;
  margin: 0 auto;
  margin-top: 10px;
}

.news_box1 {
  width: 90%;
  height: 13vw;
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  /* margin-left: 15%; */
  background-color: #fff;
  border-radius: 10px;
}

.news_img2 {
  width: 40%;
  height: 25vw;
  background: darkgreen;
}

.newsContent {
  width: 50%;
  /* height: 85%; */
  height: 200px;
  /* font-size: 1.2vw; */
  font-size: 16px;
  color: #0b449d;
  overflow: hidden;
}

.first {
  display: flex;
  font-size: 1.2vw;
  color: #0b449d;
}

.first_text {
  margin-top: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.el-tabs--left,
.el-tabs--right {
  margin-left: 0;
}

.first_text:hover {
  cursor: pointer;
  color: red;
}

.first_text2 {
  margin-left: 10vw;
  margin-top: 10px;
}

.Pagination_box {
  display: flex;
  width: 40%;
  height: 2vw;
  margin: 0 auto;
  margin-top: 2vw;
}

.Organization_box1 {
  width: 93%;
  display: flex;
  height: 17vw;
  justify-content: space-between;
  margin-top: 20px;
  margin-left: 10px;
  /* background-color: chocolate; */
}

@media screen and (min-width: 320px) and (max-width: 750px) {
  .enterpriseSlogan_cont {
    line-height: 1.5;
  }

  .corporateCulture .business {
    display: none;
  }

  .whll.rightData {
    width: 100%;
    margin-left: 20px;
    margin-right: 20px;
    margin-top: 2%;
  }

  /* 党建工作 */
  .drop-down {
    width: 100%;
  }

  .drop-down .InformationNews {
    display: none;
  }

  .drop-down .news_box1 {
    width: 100%;
    height: 100% !important;
  }

  .drop-down .enterprise_name {
    font-size: 16px;
  }

  .drop-down .newsContent {
    width: 100%;
    text-align: center;
    font-size: 14px;
  }

  .content_c {
    width: 100%;
  }

  .djgzz {
    width: 94% !important;
    margin-left: 10px !important;
    margin-right: 10px !important;
    margin-top: 1px;
  }

  .djgzz .enterprise_name {
    /* padding: 10px 0; */
    line-height: 2;
  }

  .personne2 {}

  .hezi {
    width: 100%;
  }

  /* 视频导播 */
  .spdbo {
    width: 100%;
    margin-left: 1px;
    /* margin-right: 10px; */
  }

  .videoDirector {
    width: 96%;
    margin-left: 6px;
    margin-right: 6px;
  }

  .video_box {
    width: 30%;
    height: 100%;
  }

  .video_img {
    height: 100%;
  }

  .rys {
    width: 96%;
    margin-left: 10px;
    margin-top: 1%;
  }
}
</style>
<style>
@media screen and (min-width: 320px) and (max-width: 750px) {
  .el-collapse-item__header {
    width: 22% !important;
    font-size: 12px !important;
  }

  .corporateCulture .el-tabs--left .el-tabs__item.is-left {
    display: none;
  }
}

.corporateCulture .el-submenu__title {
  text-align: center;
  background-color: #0c47a1;
  color: #fff;
}

.corporateCulture .el-submenu .el-menu .el-submenu__title {
  background-color: #fff;
  color: #000;
  border: 1px solid #eee;
  border-bottom: none;
  line-height: 1.9vw;
  height: 1.9vw;
  padding-left: 17px !important;
}

.el-menu-item:focus,
.el-menu-item:hover {
  background: #fff;
}

.el-tabs--left,
.el-tabs--right {
  /* margin-left: 5%; */
}

.el-tabs__item {
  padding: 0;
}

.el-tabs--left .el-tabs__item.is-left {
  font-size: 24px;
  height: 50px;
  padding-right: 20px !important;
}

.el-collapse-item__header {
  width: 10% !important;
  font-size: 20px !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/corporateCulture/corporateCulture.vue